<template>
  <ul class="iconic-list">
    <IconicListItem
      v-for="(item, index) in items"
      :key="index"
      :icon="item.icon"
      :icon-color="item.iconColor"
      :text="item.text"
      :url="item.url"
    />
  </ul>
</template>

<script lang="ts">

import type { IconicListItemInterface } from '~/components/atoms/IconicListItem/IconicListItemTypes';

export default defineComponent({
  name: 'IconicList',

  props: {
    items: {
      type: Array as PropType<Array<IconicListItemInterface>>,
      required: true,
    },
  },
});

</script>
